import React from "react";
import { css } from "emotion";
import { defaultStyle, stickyStyle } from "./style";

const LayoutSticky = ({ height = 100, children }) => {
	const wrapperStyle = defaultStyle(height);

	return (
		<div
			className={css`
				${wrapperStyle};
			`}
		>
			<div
				className={css`
					${stickyStyle};
				`}
			>
				{children}
			</div>
		</div>
	);
};

export default LayoutSticky;
